module.exports = __webpack_public_path__ + "static/18-387a3a7ddae9017a65f886e48dd0dcd2.jpg";